export default {
  data() {
    return {
      showCardExpiredDialog: false,
      cardExpiredReason    : '',
    };
  },
  methods: {
    $_notifyCartExpired(card) {
      if (card.visits_limit && card.visits_count >= card.visits_limit) {
        this.showCardExpiredDialog = true;
        this.cardExpiredReason     = 'visits';
      }
      console.log(card)
    }
  }
};
